// React Utils
import { Link } from "react-router-dom";
// Packages components
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
// Assets
import bckWoop from "@/assets/Logo-AppWhoop.webp"; // Placeholder image for lazy loading

// Utils
import { scrollToTop, formatFechaHoraEvento } from "@/lib/utilsUI";
import { parseUTCDate, DEFAULT_TIMEZONE } from "@/utils/dateHelpers";

export default function TicketCardPerfilUsuario({ ticket }) {
  console.log("Rendering TicketCardPerfilUsuario with ticket:", ticket);
  
  // Formatear fecha del evento usando UTC
  const formatDatetime = ticket?.fechaHoraInicio
    ? formatFechaHoraEvento(
        parseUTCDate(ticket.fechaHoraInicio, ticket.zonaHoraria || DEFAULT_TIMEZONE)?.toJSDate(),
        ticket.zonaHoraria || DEFAULT_TIMEZONE
      )
    : ticket?.dateTime;
  
  // Determinar el estado del ticket
  const isExpired = !ticket.vigente;
  const hasDiscount = ticket.discount;

  return (
    <div className="min-w-[200px] max-w-[200px] bg-aw-bluedark rounded-b-xl shadow-lg overflow-hidden relative">
      {/* Badge de estado */}
      {isExpired && (
        <div className="absolute top-2 right-2 z-10 bg-red-600 text-white text-xs px-2 py-1 rounded-full font-semibold">
          Expirado
        </div>
      )}
      {!isExpired && (
        <div className="absolute top-2 right-2 z-10 bg-aw-green text-black text-xs px-2 py-1 rounded-full font-semibold">
          Vigente
        </div>
      )}
      
      {/* Imagen del Ticket */}
      <Link
        to={`/perfil/${ticket.usuarioUid}/tickets/${ticket.uid}`}
        onClick={scrollToTop}
        className="h-52 block overflow-hidden relative border-2 border-aw-green bg-aw-bluegray"
      >
        <img
          src={bckWoop}
          alt="Placeholder"
          className="absolute inset-0 w-2/3 h-2/3 m-auto top-0 left-0 object-cover z-0"
        />
        <LazyLoadImage
          src={ticket.image || bckWoop}
          placeholderSrc={bckWoop}
          alt={ticket.title}
          height={"100%"}
          width={"100%"}
          effect="blur"
          className="w-full h-full object-cover z-50"
          loading="lazy"
        />
      </Link>
      
      <div className="px-2 py-1 flex flex-col justify-between h-[150px] text-center">
        <span className="text-tiny text-white capitalize">{formatDatetime}</span>
        <h3 className="font-bold text-sm text-white line-clamp-2">{ticket.title}</h3>
        
        {/* Tipo de ticket */}
        <span className="text-xs text-aw-green font-semibold">
          {ticket.tipoTicket?.nombre}
        </span>
        
        {hasDiscount && (
          <span className="text-aw-green font-bold text-xs">
            Ticket con Descuento
          </span>
        )}
        
        <p className="text-xs text-gray-500 line-clamp-1">
          <FontAwesomeIcon
            icon="fa-solid fa-map-pin"
            className="text-red-700 mr-1"
          />
          {ticket?.direccion}
        </p>
        
        {/* Precio pagado */}
        {/* <div className="text-white text-sm font-bold">
          ${ticket.precioPagado?.toLocaleString()}
        </div> */}
      </div>
      
      {/* Botón Ver Ticket */}
      <Link
        to={`/perfil/${ticket.usuarioUid}/tickets/${ticket.uid}`}
        onClick={scrollToTop}
        className={`w-full h-9 flex items-center justify-center text-black font-semibold text-sm mt-2 py-1 hover:scale-110 transition duration-300 ${
          isExpired ? 'bg-gray-500' : 'bg-aw-green'
        }`}
      >
        Ver Ticket
        <FontAwesomeIcon
          icon="fa-solid fa-ticket"
          className="ml-2 -rotate-z-45"
        />
      </Link>
    </div>
  );
}
